import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  verifyToken: async () => {
    const response = await api.get('/auth/verify');
    return response.data;
  }
};

export const userService = {
  getAll: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  create: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  update: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  getThingsBoardToken: async (userId) => {
    const response = await api.get(`/users/${userId}/thingsboard-token`);
    return response.data;
  }
};

export const dashboardService = {
  getAll: async () => {
    const response = await api.get('/dashboards');
    return response.data;
  },

  getById: async (dashboardId) => {
    const response = await api.get(`/dashboards/${dashboardId}`);
    return response.data;
  },

  create: async (dashboardData) => {
    const response = await api.post('/dashboards', dashboardData);
    return response.data;
  },

  update: async (dashboardId, dashboardData) => {
    const response = await api.put(`/dashboards/${dashboardId}`, dashboardData);
    return response.data;
  },

  delete: async (dashboardId) => {
    const response = await api.delete(`/dashboards/${dashboardId}`);
    return response.data;
  },

  assignToUser: async (dashboardId, assignmentData) => {
    const response = await api.post(`/dashboards/${dashboardId}/assign`, assignmentData);
    return response.data;
  },

  unassignFromUser: async (dashboardId, userId) => {
    const response = await api.delete(`/dashboards/${dashboardId}/assign/${userId}`);
    return response.data;
  },

  getAssignedUsers: async (dashboardId) => {
    const response = await api.get(`/dashboards/${dashboardId}/users`);
    return response.data;
  }
};

export const deviceService = {
  getAll: async () => {
    const response = await api.get('/devices');
    return response.data;
  },

  getById: async (deviceId) => {
    const response = await api.get(`/devices/${deviceId}`);
    return response.data;
  },

  getAttributes: async (deviceId, scope = 'SERVER_SCOPE') => {
    const response = await api.get(`/devices/${deviceId}/attributes/${scope}`);
    return response.data;
  },

  updateAttributes: async (deviceId, scope, attributes) => {
    const response = await api.post(`/devices/${deviceId}/attributes/${scope}`, attributes);
    return response.data;
  }
};

export const telemetryService = {
  get: async (deviceId, keys, startTs = null, endTs = null) => {
    const params = { keys };
    if (startTs) params.startTs = startTs;
    if (endTs) params.endTs = endTs;
    
    const response = await api.get(`/telemetry/${deviceId}`, { params });
    return response.data;
  },

  getTimeseries: async (deviceId, keys, interval = 'hourly', agg = 'SUM', startTs = null, endTs = null) => {
    const params = { keys, interval, agg };
    if (startTs) params.startTs = startTs;
    if (endTs) params.endTs = endTs;
    
    const response = await api.get(`/telemetry/${deviceId}/timeseries`, { params });
    return response.data;
  },

  getAggregated: async (deviceId, interval = 'hourly', keys = null, startTs = null, endTs = null) => {
    const params = { interval };
    if (keys) params.keys = keys;
    if (startTs) params.startTs = startTs;
    if (endTs) params.endTs = endTs;
    
    const response = await api.get(`/telemetry/${deviceId}/aggregated`, { params });
    return response.data;
  },

  getThingsBoardToken: async (userId) => {
    const response = await api.get(`/users/${userId}/thingsboard-token`);
    return response.data.token;
  },

  getThingsBoardUrl: async () => {
    // Use public endpoint that works for all authenticated users
    const response = await api.get('/admin/thingsboard/url');
    // Response format: { url: "..." }
    return response.data.url;
  }
};
